import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, Tag, Row, Col, Select, Input } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	DashboardFilled,
	EditFilled,
	PlusCircleFilled,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { franchises57Options } from "../../constants/Customer";
const { Text } = Typography;
const { Search } = Input;

const typeOptions = [
	{
		label: "All",
		value: "All",
	},
	{
		label: "Active",
		value: "Active",
	},
	{
		label: "Inactive",
		value: "Inactive",
	},
];

const columnsCSV = [
	{ key: "active", label: "Active" },
	{ key: "name", label: "Name" },
	{ key: "phone", label: "Phone" },
	{ key: "license", label: "License" },
	{ key: "plant", label: "Plant" },
	{ key: "workingHours", label: "Working Hours" },
	{ key: "comment", label: "Comment" },
];

const DriverList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [active, setActive] = useState("All");
	const [term, setTerm] = useState("");
	const [driverList, setDriverList] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "fc@57concrete.com" ||
					localStorage.getItem("email") === "jp@57concrete.com" ||
					localStorage.getItem("email") === "ac@57concrete.com" ||
					localStorage.getItem("email") === "aca@57concrete.com" ||
					localStorage.getItem("email") === "ji@57concrete.com" ? (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) => history.push(`/driver/${record.id}`)}
						size="large"
					/>
				) : (
					""
				);
			},
		},
		{
			title: "",
			dataIndex: "active",
			render: (value) => {
				return <Tag color={value === "Active" ? "green" : "red"}>{value}</Tag>;
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Phone",
			dataIndex: "phone",
			key: "phone",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "License",
			dataIndex: "license",
			key: "license",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Working Hours",
			dataIndex: "workingHours",
			key: "workingHours",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Comment",
			dataIndex: "comment",
			key: "comment",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag color={value === "57Concrete" ? "green" : "cyan"}>{value}</Tag>
				);
			},
		},
	];

	useEffect(() => {
		getDriverList(active, term, franchise);
	}, [active, term, franchise]);

	const getDriverList = async (active) => {
		setLoading(true);

		const url =
			api + `/driver/list/search/${franchise}?active=${active}&term=${term}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					name: item.name,
					phone: item.phone,
					license: item.license ? item.license : "N/A",
					plant: item.plant ? item.plant.name : "N/A",
					workingHours: item.workingHours,
					comment: item.comment ? item.comment : "N/A",
					active: item.active ? "Active" : "Inactive",
					franchise: item.franchise || "57Concrete",
				});
			});
			setDriverList(list);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewDriver = () => {
		history.push("/driver/new");
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderSearch = () => (
		<Flex gap={"large"}>
			<Select
				showSearch
				placeholder={`Select status`}
				optionFilterProp="children"
				size="large"
				onChange={(value) => setActive(value)}
				filterOption={filterOption}
				options={typeOptions}
				disabled={loading}
				defaultValue={"All"}
				value={active}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
			<Select
				showSearch
				placeholder={`Select franchise`}
				optionFilterProp="children"
				size="large"
				onChange={(value) => setFranchise(value)}
				filterOption={filterOption}
				options={franchises57Options}
				disabled={loading}
				defaultValue={"57Concrete"}
				value={franchise}
				style={{
					width: 200,
				}}
				allowClear={false}
			/>
			<Search
				placeholder="Search"
				enterButton
				onSearch={(value) => setTerm(value)}
				allowClear
				style={{
					width: 400,
				}}
				size="large"
				loading={loading}
				disabled={loading}
			/>
		</Flex>
	);

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={driverList}
					headers={columnsCSV}
					filename={"57concrete-driver-list.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col>
						{(localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "fc@57concrete.com" ||
							localStorage.getItem("email") === "jp@57concrete.com" ||
							localStorage.getItem("email") === "bpa@57concrete.com" ||
							localStorage.getItem("email") === "ac@57concrete.com" ||
							localStorage.getItem("email") === "ji@57concrete.com") && (
							<Button
								onClick={addNewDriver}
								type="primary"
								style={{
									width: 150,
								}}
								icon={<PlusCircleFilled />}
								size="large"
								loading={loading}
							>
								New Driver
							</Button>
						)}
					</Col>
					<Col>
						<Button
							size="large"
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
						>
							Download Report
						</Button>
					</Col>
					{(localStorage.getItem("email") === "rs@57concrete.com" ||
						localStorage.getItem("email") === "rf@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "ji@57concrete.com" ||
						localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Col style={{ marginLeft: "auto" }}>
							<Button
								size="large"
								type="primary"
								onClick={(e) => history.push("/driver/dashboard")}
								icon={<DashboardFilled />}
								loading={loading}
							>
								Driver Dashboard
							</Button>
						</Col>
					)}
				</Row>
			</div>
		);
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={driverList} />
			</Flex>
		);
	};

	return (
		<Layout title="Driver" description="Driver List">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default DriverList;
